import { render, staticRenderFns } from "./WithdrawalRecordList.vue?vue&type=template&id=1dd83d16&scoped=true"
import script from "./WithdrawalRecordList.vue?vue&type=script&lang=js"
export * from "./WithdrawalRecordList.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalRecordList.vue?vue&type=style&index=0&id=1dd83d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd83d16",
  null
  
)

export default component.exports